import { Grid, Typography, Box, Button } from "@material-ui/core";
import { useHistory } from "react-router";
import { useMountAPI } from "../hooks/APICall";
import useCustomState from "../hooks/State";
import Call from "../service/API";
import {
  WHITE,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  ERROR_COLOR,
  BLUE_PRIMARY,
} from "../utils/const";
import Loading from "../components/loading";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";
import moment from "jalali-moment";
import { useDispatch, useSelector } from "react-redux";
import DeleteAdminModal from "../components/deleteAdminModal";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { UpdateAdminsTable } from "../store/actions";
import { UpdateNavigations } from "../store/actions";

const AccessabilityManagement = (props) => {
  const profile = useSelector((state) => state.adminProfile);
  const updateCommands = useSelector((state) => state.updateCommands);

  const isLoading = useCustomState(true);
  const admins = useCustomState([]);

  const deleteModalOpen = useCustomState(false);
  const deletedAdmin = useCustomState({});

  const history = useHistory();
  const dispatch = useDispatch();

  const adminUtils = {
    adminName: "",
    adminPhone: "",
    adminLastname: "",
    isLoading: isLoading,
    admins: admins,
    history: history,
    dispatch: dispatch,
  };

  useMountAPI(fetchAdmins, adminUtils);

  useEffect(() => {
    const navigations = [
      { name: "مدیریت دسترسی", path: "/admin/accessability" },
    ];
    dispatch(UpdateNavigations(navigations));
  }, []);

  useEffect(() => {
    if (updateCommands.updateAdminsTable) {
      isLoading.handleChange(true);
      fetchAdmins(adminUtils);
    }
  }, [updateCommands.updateAdminsTable]);

  const goToAddAdmin = () => {
    history.push("/admin/accessability/add-admin");
  };

  const openDeleteModal = (e) => {
    const adminId = e.currentTarget.id;
    // console.log(adminId);
    const adminInfo = admins.value.filter((admin) => admin.id === adminId);
    if (adminInfo.length > 0) {
      deletedAdmin.handleChange(adminInfo[0]);
      deleteModalOpen.handleChange(true);
    } else {
      return;
    }
  };

  const renderAdminListTable = () => {
    if (isLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>نام و نام خانوادگی</TableCell>
                <TableCell align={"center"}>شماره تلفن</TableCell>
                <TableCell align={"center"}>سطح دسترسی</TableCell>
                <TableCell align={"center"}>تاریخ ثبت نام</TableCell>
                <TableCell align={"center"}>ویرایش دسترسی</TableCell>
                <TableCell align={"center"}>حذف</TableCell>
                <TableCell align={"center"}>مشاهده اطلاعات</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {admins.value.map((admin, idx) => {
                const levelStyle = {
                  color: "#fff",
                  backgroundColor: "green",
                  fontSize: "12px",
                  borderRadius: "4px",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  marginRight: "8px",
                };
                let levelText = "";
                if (admin.permissions.includes("Base")) {
                  levelStyle.backgroundColor = GREEN_PRIMRY;
                  levelText = "مدیر کل";
                } else if (admin.permissions.includes("Middle")) {
                  levelStyle.backgroundColor = BLUE_PRIMARY;
                  levelText = "مدیر پروژه";
                } else {
                  levelStyle.backgroundColor = ERROR_COLOR;
                  levelText = "تعیین نشده";
                }

                const level = <span style={levelStyle}>{levelText}</span>;

                const deleteIsActive =
                  admin.id === profile.admin_id ? false : true;

                const editIsActive = admin.permissions.includes("Middle")
                  ? true
                  : false;

                const deleteClicked = deleteIsActive
                  ? openDeleteModal
                  : () => {};
                const editLink = editIsActive
                  ? "/admin/accessability/edit-admin/" + admin.id
                  : "#";
                return (
                  <TableRow>
                    <TableCell align={"center"}>
                      {convertNumbers(idx + 1)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {admin.name + " " + admin.lastname}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(admin.phoneNumber)}
                    </TableCell>
                    <TableCell align={"center"}>{level}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        moment(admin.registeredAt)
                          .locale("fa")
                          .format("YYYY/MM/DD")
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      <Link to={editLink}>
                        <EditIcon
                          style={{
                            color: ORANGE_COLOR,
                            cursor: "pointer",
                            opacity: editIsActive ? "1" : "0.5",
                          }}
                        />
                      </Link>
                    </TableCell>
                    <TableCell align={"center"}>
                      <div onClick={deleteClicked} id={admin.id}>
                        <DeleteIcon
                          style={{
                            color: ERROR_COLOR,
                            cursor: "pointer",
                            opacity: deleteIsActive ? "1" : "0.5",
                          }}
                        />
                      </div>
                    </TableCell>
                    <TableCell align={"center"}>
                      <Link to={"/admin/accessability/admin-info/" + admin.id}>
                        <InfoIcon
                          style={{ color: BLUE_PRIMARY, cursor: "pointer" }}
                        />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderAdminList = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "48px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography style={{ fontWeight: "bold", width: "100%" }}>
                لیست مدیران دارای دسترسی
              </Typography>

              {renderAddAdminBtn()}
            </div>
          </Box>
          {renderAdminListTable()}
        </Grid>
      </>
    );
  };

  const renderAddAdminBtn = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={goToAddAdmin}
            style={{ backgroundColor: BLUE_PRIMARY, color: WHITE }}
          >
            افزودن مدیر جدید
          </Button>
        </Grid>
      </>
    );
  };

  return (
    <>
      <DeleteAdminModal open={deleteModalOpen} adminInfo={deletedAdmin.value} />
      <Grid
        container
        style={{
          marginTop: "64px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingRight: "8px",
          paddingLeft: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            backgroundColor: WHITE,
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            style={{
              maxWidth: "250px",
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "-60px",
              paddingRight: "36px",
              paddingLeft: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRadius: "12px",
              backgroundColor: GREEN_PRIMRY,
              color: WHITE,
              cursor: "pointer",
            }}
            textAlign={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>
              مدیریت دسترسی به پنل
            </Typography>
          </Box>
          <Grid container>
            {renderAdminList()}
            {/* {renderAddAdminBtn()} */}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AccessabilityManagement;

const processAdmins = (admins) => {
  const results = [];
  admins.map((admin) => {
    const data = {
      id: admin.admin_id,
      name: admin.admin_name,
      lastname: admin.admin_lastname,
      phoneNumber: admin.admin_phone,
      permissions: admin.admin_permissions,
      registeredAt: admin.admin_create_date,
      info: admin.other_information,
    };
    results.push(data);
  });
  return results;
};

const fetchAdmins = (utils) => {
  const adminName = utils.adminName;
  const adminPhone = utils.adminPhone;
  const adminLastname = utils.adminLastname;
  const isLoading = utils.isLoading;
  const admins = utils.admins;
  const history = utils.history;
  const dispatch = utils.dispatch;

  const data = {
    admin_name: adminName,
    admin_phone: adminPhone,
    admin_lastname: adminLastname,
  };

  Call("POST", "admins/admin/getAll", data)
    .then((response) => {
      // console.log("admin list: ", response);
      if (response.data.code === 200) {
        admins.handleChange(processAdmins(response.data.data));
      }
      dispatch(UpdateAdminsTable({ updateAdminsTable: false }));
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
